import { useCreateWallet, useWallets } from 'api'
import Container from 'components/Container'
import { PlusOutlined } from '@ant-design/icons'
import { FormItem, FormItemProps, Select, SelectProps } from 'formik-antd'
import { useLocalization } from 'localization'
import { FC, useState } from 'react'

import Styled from './styled'
import { Button, Input } from 'antd'

export interface IWalletFormDropdown extends Pick<FormItemProps, 'name' | 'label'>, Pick<SelectProps, 'placeholder'> {
	required?: boolean
}

const WalletFormDropdown: FC<IWalletFormDropdown> = ({ name, label, placeholder, required = false }) => {
	const { t } = useLocalization()
	const { walletOptions } = useWallets()
	const [newWalletName, setNewWalletName] = useState('')
	const { mutateAsync: createWallet } = useCreateWallet()

	const addWallet = async (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
		e.preventDefault()
		if (newWalletName.length >= 3) {
			await createWallet({
				name: newWalletName,
				address: '', // TODO: BE should allow empty field
			})
			setNewWalletName('')
		}
	}

	return (
		<FormItem name={name} label={label} required={required}>
			<Select
				showSearch
				name={name}
				placeholder={placeholder}
				options={walletOptions}
				dropdownRender={menu => (
					<>
						{menu}
						<Styled.NewOptionDivider />
						<Container
							display="flex"
							padding={{ left: 'sm', right: 'sm', bottom: 'xs' }}
							space="xs"
							flexDirection="column"
							spaceDirection="vertical"
						>
							<Input
								style={{ minWidth: 'auto' }}
								size="small"
								placeholder={t('placeholders.newWalletName')}
								value={newWalletName}
								onChange={e => setNewWalletName(e.target.value)}
							/>
							<Button
								size="small"
								type="primary"
								disabled={newWalletName.length < 3}
								icon={<PlusOutlined />}
								onClick={addWallet}
							>
								{t('actions.createWallet')}
							</Button>
						</Container>
					</>
				)}
			/>
		</FormItem>
	)
}

export default WalletFormDropdown
